import { Component } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { PageEvent } from '@angular/material/paginator';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/shared/services/auth.service';
import { PathwayMappingService } from 'src/shared/services/pathway-mapping.service';
import { ResponseService } from 'src/shared/services/response-service.service';
import { SchoolProgramService } from 'src/shared/services/school-program.service';
import { TranslateService } from 'src/shared/services/translate.service';

@Component({
  selector: 'app-report-registered',
  templateUrl: './report-registered.component.html',
  styleUrl: './report-registered.component.scss'
})
export class ReportRegisteredComponent {

  paramForm: FormGroup;
  columnsToDisplay = ['student_name', 'nis', 'class_name', 'total_participated', 'participated'];
  reportData: any[] = [];
  yearLevelRelations: any[] = [];
  yearLevelRelationsSelected: any[] = [];
  loading = false;
  loadingExport = false;
  apiSubscription: Subscription;
  exportSubscription: Subscription;
  checkboxForm!: FormGroup<{ [key: string]: FormControl<boolean> }>;

  total = 0;
  currentPage = 1;
  sort = 'asc';
  orderBy = 'student_name';
  searchText: string = '';

  constructor(
    private translate: TranslateService,
    private schoolProgramService: SchoolProgramService,
    private rpSer: ResponseService,
    public auth: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    private pmService: PathwayMappingService
  ){
    this.initForm();
  }

  ngOnInit(): void {
    this.auth.loadPermissions(true);
    this.translate.load('extracurricular', 'activity');
  }

  viewAccumulationSetup() {
    this.router.navigate(['accumulation-setup'], { relativeTo: this.route });
  }

  click() {
    console.log(this.paramForm.value);
  }

  onChangePage(event: PageEvent) {
    this.currentPage = event.pageIndex + 1;

    this.getRegisteredReport();
  }

  onSort(order: string) {
   this.sort = this.sort == 'asc' ? 'desc' : 'asc';
    this.orderBy = order;

    this.getRegisteredReport();
  }

  changeSearch(event: any) {
    console.log(event);
    this.currentPage = 1;
    this.searchText = event;

    this.getRegisteredReport();
  }

  initForm() {
    this.paramForm = new FormGroup({
      'academic_year': new FormControl(null),
      'school_location_id': new FormControl(null),
      'school_level_id': new FormControl(null),
      'school_program_id': new FormControl(null),
      'year_level_id': new FormControl(null),
      
      'school_short_address': new FormControl(null),
      'school_program_name': new FormControl(null),
      'year_level_name': new FormControl(null),
    });
  }

  onChangeAcademicYear(item: any) {
    this.paramForm.controls['academic_year'].markAsTouched();
    this.paramForm.controls['academic_year'].setValue(item ? item.academic_year : null);
  }

  onChangeSchoolLevel(item: any) {
    this.paramForm.controls['school_location_id'].markAsTouched();
    this.paramForm.controls['school_location_id'].setValue(item ? item.school_location_id : null);

    this.paramForm.controls['school_level_id'].markAsTouched();
    this.paramForm.controls['school_level_id'].setValue(item ? item.school_level_id : null);

    this.paramForm.controls['school_short_address'].setValue(item ? item.school_short_address : null);

    if (item) {
      this.paramForm.controls['year_level_id'].setValue(null);
      this.paramForm.controls['school_program_id'].setValue(null);
      this.getNewPathwayMapping();
    }
  }

  onChangeYearLevel(item: any) {
    this.paramForm.controls['year_level_id'].markAsTouched();
    this.paramForm.controls['year_level_id'].setValue(item ? item.year_level_id : null);

    this.paramForm.controls['year_level_name'].setValue(item ? item.description : null);

    if (item) {
      this.getRegisteredReport();
    }
  }

  onChangeSchoolProgram(item: any) {
    this.paramForm.controls['school_program_id'].markAsTouched();
    this.paramForm.controls['school_program_id'].setValue(item ? item.school_program_id : null);

    this.paramForm.controls['school_program_name'].setValue(item ? item.school_program_name : null);

    if (item) {
      this.getRegisteredReport();
    }
  }

  getNewPathwayMapping(option: any = null) {
    let params = {};
    if (option === 'add') {
      params = {
        academic_year: this.paramForm.controls['academic_year'].value,
        school_location_id: this.paramForm.controls['school_location_id'].value,
        school_level_id: this.paramForm.controls['school_level_id'].value,
      }
    } else {
      params = {
        academic_year: this.paramForm.controls['academic_year'].value,
        school_location_id: this.paramForm.controls['school_location_id'].value,
        school_level_id: this.paramForm.controls['school_level_id'].value,
      }
    }
    this.pmService.yearLevelNoAcademic(params)
      .subscribe((response: any) => {
        if (response.status) {
          this.yearLevelRelations = response.data.slice();
        } else {
        }
      }, (error: any) => {
      });
  }

  mapReportData(data: any): any[] {
    if (!Array.isArray(data)) {
      return [];
    }
    return data.map((item: any) => {
      const participated = Array.isArray(item.participated) ? item.participated : [];
      return {
        ...item,
        participated,
        total_participated: item.total_participated ?? participated.length,
        activity_names: participated
          .map((activity: any) => (activity.activity_name || '').trim())
          .filter((name: string) => !!name)
          .join(', '),
      };
    });
  }

  getRegisteredReport() {
    if (this.apiSubscription) {
      this.apiSubscription.unsubscribe();
    }
    this.loading = true;
    const params = {
      ...this.paramForm.value,
      page: this.currentPage,
      pagination: true,
      sort: this.sort,
      orderBy: this.orderBy,
      search: this.searchText.trim() || null
    };
    this.apiSubscription = this.schoolProgramService.getRegisteredReport(params).subscribe({
      next: (response: any) => {
        if (response.status) {
          this.reportData = this.mapReportData(response.data);
          this.total = response.meta.total;
        } else {
          this.rpSer.showAddError(response.message);
        }
        this.loading = false;
      },
      error: (error: any) => {
        this.loading = false;
        this.rpSer.showAddError(error.message);
      }
    });
  }
  
  onExportReport() {
    if (this.exportSubscription) {
      this.exportSubscription.unsubscribe();
    }
    
    // Validate form before export
    if (!this.paramForm.valid || !this.paramForm.get('school_program_id')?.value) {
      this.rpSer.showAddError('Please fill all required fields before exporting.');
      return;
    }

    this.loadingExport = true;
    const params = this.paramForm.value;
    
    this.exportSubscription = this.schoolProgramService.exportRegisteredReport(params).subscribe({
      next: (response: Blob) => {
        try {
          // Validate response is actually a blob/file
          if (!response || response.size === 0) {
            throw new Error('Empty file received from server');
          }

          // Check if response is an error (sometimes APIs return JSON error as blob)
          if (response.type === 'application/json') {
            const reader = new FileReader();
            reader.onload = () => {
              try {
                const errorData = JSON.parse(reader.result as string);
                this.rpSer.showAddError(errorData.message || 'Export failed');
              } catch {
                this.rpSer.showAddError('Invalid response format');
              }
            };
            reader.readAsText(response);
            this.loadingExport = false;
            return;
          }

          // Generate filename with timestamp
          const timestamp = new Date().toISOString().slice(0, 19).replace(/:/g, '-');
          const filename = `School_Program_Registered_Report_${timestamp}.xlsx`;
          
          // Create and trigger download
          const blobUrl = URL.createObjectURL(response);
          const link = document.createElement('a');
          link.href = blobUrl;
          link.download = filename;
          link.style.display = 'none';
          
          // Add to DOM, click, and cleanup
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          
          // Cleanup blob URL after a delay to ensure download starts
          setTimeout(() => {
            URL.revokeObjectURL(blobUrl);
          }, 1000);
          
          this.loadingExport = false;
          this.rpSer.showAddSuccess('Report exported successfully!');
          
        } catch (error: any) {
          this.loadingExport = false;
          this.rpSer.showAddError(`Export failed: ${error.message}`);
        }
      },
      error: (error: any) => {
        this.loadingExport = false;
        const errorMessage = error.error?.message || error.message || 'Export failed. Please try again.';
        this.rpSer.showAddError(errorMessage);
      }
    });
  }
}
